import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select';
import Swal from "sweetalert2";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';


const STATUS_CONFIG = {
    submitted: { label: 'Submitted', className: 'badge bg-warning text-dark' },
    reverted: { label: 'Reverted', className: 'badge bg-danger text-white' },
    approved: { label: 'Approved', className: 'badge bg-success text-white' },
};

export default function IMUStudentMark() {

    const [admissionYears, setAdmissionYears] = useState([]);
    const [admissionYear, setAdmissionYear] = useState(null);
    const [isolist, setIsolist] = useState([]);
    const [selectedISO, setSelectedISO] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [issaved, setissaved] = useState(false);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [sortBy, setSortBy] = useState({ column: '', direction: 'asc' });
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [total, setTotal] = useState(0);
    const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);

    const { http } = Api();
    const navigate = useNavigate();
    const isAuth = useAuth();

    if (isAuth === false) navigate("/ino/");

    const cid = localStorage.getItem("collegeid");



    /* ── Fetch admission years ─────────────────────────────────── */
    useEffect(() => {
        http.get('/College/getSFASideActiveAdmissionYear')
            .then(res => {
                setAdmissionYears(res.data
                    .filter(y => y.admission_year !== 2025)
                    .map(y => ({
                        id: y.id, value: y.admission_year, label: y.admission_year,
                    })));
            })
            .catch(() => {
                setAdmissionYears([]);
                toast.error("Error fetching admission years");
            });
    }, []);

    /* ── Fetch ISO list when admission year changes ────────────── */
    useEffect(() => {
        if (!admissionYear?.value) {
            setIsolist([]); setSelectedISO(null); setTableData([]); return;
        }
        http.get('/College/ListAllIso', { params: { admission_year: admissionYear.value } })
            .then(res => {
                setIsolist(res.data.data || []);
            })
            .catch(() => {
                setIsolist([]);
                toast.error("Error fetching supervisors");
            });
    }, [admissionYear]);

    /* ── Fetch student list for selected ISO ───────────────────── */
    useEffect(() => {
        if (!selectedISO?.value || !admissionYear?.value) { setTableData([]); return; }

        http.get('/College/viewStudentListISO', {
            params: {
                faculty_id: selectedISO.value,
                admission_year: admissionYear.value,
            },
        })
            .then(res => {
                const raw = res.data.studentlist ?? [];

                const list = (Array.isArray(raw) ? raw : []).map(s => ({
                    ...s,
                    ime_id: s.ime_id ?? s.id,
                    apaar_id: s.apaar_no,
                    cca_co1_actual: s.interal_co1,
                    cca_co2_actual: s.interal_co2,
                    cca_co1_max: s.cca_max,
                    cca_co2_max: s.cca_max,
                    ese_co1_actual: s.external_co1,
                    ese_co2_actual: s.external_co2,
                    ese_co1_max: s.ese_max,
                    ese_co2_max: s.ese_max,
                    mark_status:
                        s.mark_entry_status === '2' ? 'submitted'
                            : s.mark_entry_status === '3' ? 'approved'
                                : s.mark_entry_status === '4' ? 'reverted'
                                    : s.mark_entry_status === '5' ? 'principal approved'
                                        : s.mark_entry_status === '6' ? 'principal reverted'
                                            : 'pending'
                }));

                setTableData(list);
                setSelectedStudents([]);
                setIsSelectAllChecked(false);
            })
            .catch(() => {
                setTableData([]);
                toast.error("Error fetching student list");
            });
    }, [selectedISO, admissionYear, issaved]);


    const handleSearchInputChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1);
    };

    const handleSort = (column) => {
        setSortBy(prev => ({
            column,
            direction: prev.column === column && prev.direction === 'asc' ? 'desc' : 'asc',
        }));
    };

    const renderSortIcon = (columnName) => {
        if (sortBy.column === columnName) {
            return sortBy.direction === 'asc'
                ? <i className="fa fa-sort-up ml-1"></i>
                : <i className="fa fa-sort-down ml-1"></i>;
        }
        return <i className="fa fa-sort ml-1" style={{ color: '#ccc' }}></i>;
    };

    useEffect(() => {
        const filtered = [...tableData].filter(row =>
            (row.studentname ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
            (row.PRN ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
            (row.discipline_name ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
            (row.internship_topic ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
            (row.mark_status ?? '').toLowerCase().includes(searchQuery.toLowerCase())
        ).sort((a, b) => {
            if (!sortBy.column) return 0;
            return sortBy.direction === 'asc'
                ? a[sortBy.column] > b[sortBy.column] ? 1 : -1
                : a[sortBy.column] < b[sortBy.column] ? 1 : -1;
        });

        const itemsPerPage = 50;
        const startIndex = (currentPage - 1) * itemsPerPage;
        setfilteredAndSortedData(filtered.slice(startIndex, startIndex + itemsPerPage));
        setTotalPages(Math.ceil(filtered.length / itemsPerPage));
        setTotal(filtered.length);
    }, [searchQuery, sortBy, tableData, currentPage]);


    const handleISOSelectChange = (opt) => {
        if (opt?.value === selectedISO?.value) return;
        setSelectedISO(opt);
        setSelectedStudents([]);
        setIsSelectAllChecked(false);
        setCurrentPage(1);
        setSearchQuery('');
    };

    const handleAdmissionYearChange = (opt) => {
        setAdmissionYear(opt);
        setSelectedISO(null);
        setTableData([]);
        setSelectedStudents([]);
        setIsSelectAllChecked(false);
        setCurrentPage(1);
        setSearchQuery('');
    };

    console.log(selectedISO);

    const handleCheckboxChange = (imeId) => {
        setSelectedStudents(prev => {
            const updated = prev.includes(imeId)
                ? prev.filter(id => id !== imeId)
                : [...prev, imeId];
            if (updated.length === 0) setIsSelectAllChecked(false);
            return updated;
        });
    };

    const handleSelectAll = () => {
        const allSelected = !isSelectAllChecked;
        setIsSelectAllChecked(allSelected);
        setSelectedStudents(allSelected
            ? tableData.filter(s => s.mark_status === 'submitted').map(s => s.ime_id)
            : []
        );
    };

    const handleMarkAction = (action, imeIds) => {
        if (!imeIds.length) {
            toast.error('No records selected');
            return;
        }

        http.post('/College/updateInternshipMarksStatus', {
            ime_ids: imeIds,
            action: action,
        }).then(res => {
            if (res.data.status_code === 'MSG3') {
                setissaved(v => !v);
                setSelectedStudents([]);
                setIsSelectAllChecked(false);
                toast.success(res.data.message);
            } else {
                toast.error(res.data.message || `Failed to ${action}`);
            }
        }).catch(() => toast.error('Something went wrong'));
    };

    useEffect(() => {
        const submittedIds = tableData
            .filter(s => s.mark_status === 'submitted')
            .map(s => s.ime_id);

        if (submittedIds.length === 0) {
            setIsSelectAllChecked(false);
            return;
        }

        const allSelected = submittedIds.every(id => selectedStudents.includes(id));
        setIsSelectAllChecked(allSelected);
    }, [selectedStudents, tableData]);

    /* Download PDF */
    const handleGeneratePDF = async () => {
        try {
            const response = await http.get('/College/studentListISOpdf', {
                params: { admission_year: admissionYear?.value, faculty_id: selectedISO?.value },
                responseType: 'blob',
            });
            console.log(selectedISO)
            if (response?.data) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `IS_Student_Marks_${selectedISO?.label}.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                toast.success('PDF downloaded successfully');
            }
        } catch {
            toast.error('Error generating PDF');
        }
    };

    /* ── Helpers ──────────────────────────────────────────────── */

    const markCell = (actual, max) =>
        actual === null || actual === undefined
            ? <span className="text-muted fst-italic">— / {max}</span>
            : <span><strong>{actual}</strong> / {max}</span>;

    const hasSubmitted = tableData.some(r => r.mark_status === 'submitted');
    const canApprove = selectedStudents.length > 0;

    const customStyles = {
        menu: p => ({ ...p, maxHeight: '200px', overflowY: 'auto', textAlign: 'left' }),
        menuList: p => ({ ...p, maxHeight: '180px', overflowY: 'auto', scrollbarWidth: 'thin', textAlign: 'left' }),
    };

    /* ── Render ───────────────────────────────────────────────── */

    return (
        <>
            <ToastContainer />
            <Template>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">

                                <div className="card-header">
                                    <div className="py-3 d-flex justify-content-between align-items-center">
                                        <h5 className="mb-0">Student-Internship Mark Approval</h5>
                                    </div>
                                </div>

                                <div className="card-body">

                                    {/* ── FILTERS ── */}
                                    <div className="row mb-4">
                                        <div className="col-md-4">
                                            <label>Admission Year <span className="errorclr">*</span></label>
                                            <Select
                                                maxMenuHeight={200}
                                                menuPlacement="auto"
                                                className="form"
                                                styles={customStyles}
                                                options={admissionYears}
                                                value={admissionYear}
                                                onChange={handleAdmissionYearChange}
                                                placeholder="Select Admission Year..."
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <label>Internship Supervisor <span className="errorclr">*</span></label>
                                            <Select
                                                maxMenuHeight={200}
                                                menuPlacement="auto"
                                                className="form"
                                                styles={customStyles}
                                                isDisabled={!admissionYear?.value}
                                                placeholder={admissionYear?.value ? "Select Supervisor..." : "Select Admission Year first"}
                                                value={selectedISO}
                                                onChange={handleISOSelectChange}
                                                options={
                                                    isolist.length === 0
                                                        ? [{ value: '0', label: 'No supervisors found', isDisabled: true }]
                                                        : isolist
                                                            .sort((a, b) => a.fac_name.localeCompare(b.fac_name))
                                                            .map(item => ({ value: item.fac_pk, label: item.fac_name }))
                                                }
                                            />
                                        </div>
                                    </div>

                                    {/* ── ACTION BAR ── */}
                                    {tableData.length > 0 && (
                                        <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">

                                            {/* LEFT SIDE — Download + Bulk Approve */}
                                            <div className="d-flex align-items-center gap-2">

                                                {/* Download Button */}
                                                <button
                                                    className="lbl2 btn btn-primary btn-sm"
                                                    onClick={() => handleGeneratePDF()}
                                                    title="Download"
                                                >
                                                    <i className="bi bi-arrow-down-square"></i>
                                                </button>

                                                {/* Bulk Approve */}
                                                {canApprove && (
                                                    <button
                                                        className="btn btn-success btn-sm"
                                                        onClick={() => {
                                                            Swal.fire({
                                                                title: '<span style="font-size:1.2rem;font-weight:700;color:#1a1a2e">Forward Selected Students?</span>',
                                                                icon: 'question',
                                                                showCancelButton: true,
                                                                confirmButtonColor: '#198754',
                                                                cancelButtonColor: '#6c757d',
                                                                confirmButtonText: '<i class="fa fa-paper-plane"></i>&nbsp; Yes, Forward All',
                                                                cancelButtonText: 'Cancel',
                                                                reverseButtons: true,
                                                                focusCancel: true,
                                                            }).then(result => {
                                                                if (result.isConfirmed) handleMarkAction('approve_ino', selectedStudents);
                                                            });
                                                        }}
                                                    >
                                                        <i className="fa fa-check me-1"></i>
                                                        Approve & Forward to Principal ({selectedStudents.length})
                                                    </button>
                                                )}

                                            </div>


                                            {/* RIGHT SIDE — Search */}
                                            <div>
                                                <input
                                                    type="text"
                                                    value={searchQuery}
                                                    onChange={handleSearchInputChange}
                                                    placeholder="Search..."
                                                    className="form-control"
                                                    style={{ width: "350px" }}
                                                />
                                            </div>

                                        </div>
                                    )
                                    }



                                    {/* ── MARKS TABLE ── */}
                                    <div class="table-container mt-1">
                                        <table className="display dataTable table-striped table-bordered" id="dataTable">

                                            <thead className="table-primary text-center">
                                                <tr className="bg-primary">
                                                    <th rowSpan="2" style={{ verticalAlign: 'middle', width: '40px' }}>
                                                        {hasSubmitted && (
                                                            <input
                                                                type="checkbox"
                                                                checked={isSelectAllChecked}
                                                                onChange={handleSelectAll}
                                                            />
                                                        )}
                                                    </th>
                                                    <th rowSpan="2" style={{ verticalAlign: 'middle', width: '45px' }}>Sl No</th>
                                                    <th rowSpan="2" className='text-center' style={{ verticalAlign: 'middle', cursor: 'pointer' }} onClick={() => handleSort('PRN')}>
                                                        Student {renderSortIcon('PRN')}
                                                    </th>
                                                    <th rowSpan="2" style={{ verticalAlign: 'middle', cursor: 'pointer' }} onClick={() => handleSort('discipline_name')}>
                                                        Discipline {renderSortIcon('discipline_name')}
                                                    </th>
                                                    <th rowSpan="2" style={{ verticalAlign: 'middle', cursor: 'pointer' }} onClick={() => handleSort('internship_topic')}>
                                                        Internship Topic {renderSortIcon('internship_topic')}
                                                    </th>
                                                    {/* <th rowSpan="2" style={{ verticalAlign: 'middle' }}>Supervisor</th> */}
                                                    <th colSpan="2" className="text-center border-start">CCA</th>
                                                    <th colSpan="2" className="text-center border-start">ESE</th>
                                                    <th rowSpan="2" className="text-center border-start" style={{ verticalAlign: 'middle' }}>Action</th>
                                                </tr>
                                                <tr className='bg-primary'>
                                                    <th className="border-start text-center border-top" style={{ minWidth: '70px', width: '100px' }}>CO1<br /><small className="fw-normal">Actual / Max</small></th>
                                                    <th className="text-center border-top" style={{ minWidth: '70px', width: '100px' }}>CO2<br /><small className="fw-normal">Actual / Max</small></th>
                                                    <th className="border-start text-center border-top" style={{ minWidth: '70px', width: '100px' }}>CO1<br /><small className="fw-normal">Actual / Max</small></th>
                                                    <th className="border-top text-center" style={{ minWidth: '70px', width: '100px' }}>CO2<br /><small className="fw-normal">Actual / Max</small></th> </tr>
                                            </thead>

                                            <tbody>
                                                {filteredAndSortedData.length > 0 ? (
                                                    filteredAndSortedData.map((row, index) => (
                                                        <tr key={row.ime_id}>
                                                            <td className="text-center">
                                                                {row.mark_status === 'submitted' ? (
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedStudents.includes(row.ime_id)}
                                                                        onChange={() => handleCheckboxChange(row.ime_id)}
                                                                    />
                                                                ) : <span class="badge badge-success text-white rounded-pill"><i class="fa fa-check" aria-hidden="true"></i></span>
                                                                }
                                                            </td>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td>
                                                                <div>
                                                                    {row.PRN || '—'}
                                                                    {row.studentname ? ` / ${row.studentname}` : ''}
                                                                </div>
                                                            </td>
                                                            <td>{row.discipline_name}</td>
                                                            <td>{row.internship_topic || '—'}</td>
                                                            <td className="text-center border-start">{markCell(row.cca_co1_actual, row.cca_co1_max)}</td>
                                                            <td className="text-center">{markCell(row.cca_co2_actual, row.cca_co2_max)}</td>
                                                            <td className="text-center border-start">{markCell(row.ese_co1_actual, row.ese_co1_max)}</td>
                                                            <td className="text-center">{markCell(row.ese_co2_actual, row.ese_co2_max)}</td>
                                                            <td className="text-center">
                                                                {row.mark_status === 'submitted' && (
                                                                    <div className="d-flex gap-2 justify-content-center align-items-center">
                                                                        <button
                                                                            type="button"
                                                                            title="Approve & Forward to Principal"
                                                                            onClick={() => {
                                                                                Swal.fire({
                                                                                    title: 'Approve & Forward?',
                                                                                    text: 'This will approve the marks and forward to the Principal.',
                                                                                    icon: 'question',
                                                                                    showCancelButton: true,
                                                                                    confirmButtonColor: '#198754',
                                                                                    cancelButtonColor: '#6c757d',
                                                                                    confirmButtonText: 'Yes, Forward',
                                                                                    cancelButtonText: 'Cancel',
                                                                                }).then(result => {
                                                                                    if (result.isConfirmed) handleMarkAction('approve_ino', [row.ime_id]);
                                                                                });
                                                                            }} style={{
                                                                                display: 'inline-flex', alignItems: 'center', gap: '5px',
                                                                                padding: '4px 12px', fontSize: '0.75rem', fontWeight: '600',
                                                                                letterSpacing: '0.04em', borderRadius: '20px', cursor: 'pointer',
                                                                                border: '1.5px solid #198754', color: '#198754', background: 'transparent',
                                                                                transition: 'all 0.2s ease',
                                                                            }}
                                                                            onMouseEnter={e => { e.currentTarget.style.background = '#198754'; e.currentTarget.style.color = '#fff'; }}
                                                                            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#198754'; }}
                                                                        >
                                                                            <i className="fa fa-paper-plane" style={{ fontSize: '0.7rem' }}></i> Forward
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            title="Revert to Supervisor for correction"
                                                                            onClick={() => {
                                                                                Swal.fire({
                                                                                    title: 'Revert to Supervisor?',
                                                                                    text: 'Marks will be sent back to the supervisor for correction.',
                                                                                    icon: 'warning',
                                                                                    showCancelButton: true,
                                                                                    confirmButtonColor: '#e67e22',
                                                                                    cancelButtonColor: '#6c757d',
                                                                                    confirmButtonText: 'Yes, Revert',
                                                                                    cancelButtonText: 'Cancel',
                                                                                }).then(result => {
                                                                                    if (result.isConfirmed) handleMarkAction('revert_ino', [row.ime_id]);
                                                                                });
                                                                            }} style={{
                                                                                display: 'inline-flex', alignItems: 'center', gap: '5px',
                                                                                padding: '4px 12px', fontSize: '0.75rem', fontWeight: '600',
                                                                                letterSpacing: '0.04em', borderRadius: '20px', cursor: 'pointer',
                                                                                border: '1.5px solid #e67e22', color: '#e67e22', background: 'transparent',
                                                                                transition: 'all 0.2s ease',
                                                                            }}
                                                                            onMouseEnter={e => { e.currentTarget.style.background = '#e67e22'; e.currentTarget.style.color = '#fff'; }}
                                                                            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#e67e22'; }}
                                                                        >
                                                                            <i className="fa fa-undo" style={{ fontSize: '0.7rem' }}></i> Revert
                                                                        </button>
                                                                    </div>
                                                                )}
                                                                {row.mark_status === 'approved' && (
                                                                    <span style={{
                                                                        display: 'inline-flex', alignItems: 'center', gap: '5px',
                                                                        padding: '4px 12px', fontSize: '0.75rem', fontWeight: '600',
                                                                        letterSpacing: '0.04em', borderRadius: '20px',
                                                                        border: '1.5px solid #198754', color: '#198754', background: 'transparent',
                                                                    }}>
                                                                        Forwarded
                                                                    </span>
                                                                )}

                                                                {row.mark_status === 'reverted' && (
                                                                    <span style={{
                                                                        display: 'inline-flex', alignItems: 'center', gap: '5px',
                                                                        padding: '4px 12px', fontSize: '0.75rem', fontWeight: '600',
                                                                        letterSpacing: '0.04em', borderRadius: '20px',
                                                                        border: '1.5px solid #dc3545', color: '#dc3545', background: 'transparent',
                                                                    }}>
                                                                        Reverted
                                                                    </span>
                                                                )}

                                                                {row.mark_status === 'principal approved' && (
                                                                    <span style={{
                                                                        display: 'inline-flex', alignItems: 'center', gap: '5px',
                                                                        padding: '4px 12px', fontSize: '0.75rem', fontWeight: '600',
                                                                        letterSpacing: '0.04em', borderRadius: '20px',
                                                                        border: '1.5px solid #0d6efd', color: '#0d6efd', background: 'transparent',
                                                                    }}>
                                                                        Principal Approved
                                                                    </span>
                                                                )}

                                                                {row.mark_status === 'principal reverted' && (
                                                                    <span style={{
                                                                        display: 'inline-flex', alignItems: 'center', gap: '5px',
                                                                        padding: '4px 12px', fontSize: '0.75rem', fontWeight: '600',
                                                                        letterSpacing: '0.04em', borderRadius: '20px',
                                                                        border: '1.5px solid #dc3545', color: '#dc3545', background: 'transparent',
                                                                    }}>
                                                                        Principal Reverted
                                                                    </span>
                                                                )}

                                                                {row.mark_status === 'pending' && (
                                                                    <span style={{
                                                                        display: 'inline-flex', alignItems: 'center', gap: '5px',
                                                                        padding: '4px 12px', fontSize: '0.75rem', fontWeight: '600',
                                                                        letterSpacing: '0.04em', borderRadius: '20px',
                                                                        border: '1.5px solid #adb5bd', color: '#6c757d', background: 'transparent',
                                                                    }}>
                                                                        Not Submitted
                                                                    </span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="12" className="text-center py-4 text-muted">
                                                            {selectedISO
                                                                ? 'No student marks found for this supervisor'
                                                                : 'Select an admission year and supervisor to view marks'}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* ── LEGEND ── */}
                                    {/* {tableData.length > 0 && (
                                        <div className="d-flex flex-wrap gap-3 mt-2" style={{ fontSize: '0.8rem', color: '#555' }}>
                                            <span><span className="badge bg-warning text-dark me-1">Submitted</span>Marks entered by supervisor, pending INO review</span>
                                            <span><span className="badge bg-danger me-1">Reverted</span>Sent back to supervisor for correction</span>
                                            <span><span className="badge bg-success me-1">Approved</span>Forwarded to Principal</span>
                                        </div>
                                    )} */}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Template>
        </>
    );
}